<div *ngIf="step === 2" class="br-flex br-flex-wrap br-items-center br-gap-2 br-mb-2">
  <strong>{{ choosingLeads ? 'Choose Leads to add' : 'In this campaign' }}</strong>
  <span class="br-text-muted">{{ membersLoaded ? members.size : 'Loading...' }} in campaign</span>
  <button *ngIf="selectable && undoChange" type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
          [disabled]="busy" (click)="undo()">Undo last change</button>
  <ng-content select="[campaign-target-actions]"></ng-content>
</div>
<p *ngIf="choosingLeads" class="br-text-muted br-mb-2">Choose from the list or map. Leads marked In campaign are excluded from the number to add.</p>
<p *ngIf="choosingLeads && selectionError" class="br-alert br-alert--danger" role="alert">{{ selectionError }}
  <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" (click)="refreshSelectionCount()">Retry</button>
</p>
<ng-template #campaignStatus let-row><span *ngIf="members.has(row.leadId)" class="br-text-muted">In campaign</span></ng-template>
<p *ngIf="notice" role="status">{{ notice }}</p>
<p *ngIf="error" class="br-alert br-alert--danger" role="alert">{{ error }}</p>
<!-- Choosing uses the Leads collection itself; its checkboxes are the Leads map selection. -->
<app-leads-board *ngIf="choosingLeads" [selectionOnly]="true" [selectionBinding]="leadSelection" [selectionStatus]="campaignStatus"
                 [selectedIds]="filteredSelectionIds" [excludeSelectedIds]="selectionFilter === 'unselected'">
  <select lead-search-actions class="br-form-select br-form-select--sm br-w-auto" aria-label="Lead selection filter"
          [ngModel]="selectionFilter" (ngModelChange)="setSelectionFilter($event)">
    <option value="all">All Leads</option>
    <option value="selected">Selected</option>
    <option value="unselected">Unselected</option>
  </select>
</app-leads-board>
<ng-container *ngIf="!choosingLeads">
<ng-template #assigneePicker let-row>
  <select *ngIf="actionStep && canManage; else assigneeText" class="br-form-select br-form-select--sm"
          [attr.aria-label]="'Assignee for ' + (row.title || 'Lead #' + row.leadId)"
          [disabled]="busy || assigneesLoading || !assigneesLoaded || !membersLoaded"
          (change)="setAssignee(row, $any($event.target).value); $any($event.target).value = row.salesRepUserId ?? ''">
    <option value="" [selected]="row.salesRepUserId == null" disabled>Select assignee</option>
    <option *ngIf="row.salesRepUserId != null && !hasAssignee(row.salesRepUserId)" [value]="row.salesRepUserId" [selected]="true" disabled>{{ assigneeLabel(row.salesRepUserId) }}</option>
    <option *ngFor="let assignee of assignees" [value]="assignee.id" [selected]="assignee.id === row.salesRepUserId">{{ assigneeLabel(assignee.id) }}</option>
  </select>
  <ng-template #assigneeText>{{ assigneeLabel(row.salesRepUserId) }}</ng-template>
</ng-template>
<ng-template #duePicker let-row>
  <input *ngIf="actionStep && canManage; else dueText" type="date" class="br-form-control br-form-control--sm"
         [attr.aria-label]="'Due date for ' + (row.title || 'Lead #' + row.leadId)"
         min="2000-01-01" [value]="dueDateValue(row.nextActionDue)" [disabled]="busy || !membersLoaded"
         (change)="setDueDate(row, $any($event.target).value); $any($event.target).value = dueDateValue(row.nextActionDue)">
  <ng-template #dueText>{{ row.nextActionDue ? (row.nextActionDue | date:'mediumDate') : 'Not set' }}</ng-template>
</ng-template>
<ng-template #bulkPlan let-selection>
  <div class="br-flex br-flex-wrap br-items-center br-gap-2">
    <select class="br-form-select br-form-select--sm br-w-auto" aria-label="Bulk assignee"
            [(ngModel)]="bulkAssignee" [disabled]="busy || !assigneesLoaded">
      <option [ngValue]="null">Assignee: keep unchanged</option>
      <option *ngFor="let assignee of assignees" [ngValue]="assignee.id">{{ assigneeLabel(assignee.id) }}</option>
    </select>
    <select class="br-form-select br-form-select--sm br-w-auto" aria-label="Bulk action"
            [(ngModel)]="bulkAction" [disabled]="busy || !actionsLoaded">
      <option value="">Action: keep unchanged</option>
      <option *ngFor="let action of actionTypes" [value]="action.label">{{ action.label }}</option>
    </select>
    <label class="br-flex br-items-center br-gap-2 br-m-0">Due date
      <input type="date" class="br-form-control br-form-control--sm br-w-auto" min="2000-01-01"
             [(ngModel)]="bulkDue" [disabled]="busy" aria-label="Bulk due date">
    </label>
    <button type="button" class="br-btn br-btn--primary br-btn--sm"
            [disabled]="busy || !membersLoaded || !hasBulkChanges || !selection.hasValue()"
            (click)="applyBulk(selection)">{{ allMembersSelected ? 'Apply to all ' + members.size : 'Apply to selected' }}</button>
    <span *ngIf="pageFullySelected && members.size > selection.selected.length" class="br-text-muted">
      <ng-container *ngIf="!allMembersSelected; else allChosen">All {{ selection.selected.length }} on this page are selected.
        <button type="button" class="br-btn br-btn--link br-btn--sm" [disabled]="busy" (click)="selectAllMembers()">Select all {{ members.size }} in this campaign</button></ng-container>
      <ng-template #allChosen>All {{ members.size }} Leads in this campaign are selected.
        <button type="button" class="br-btn br-btn--link br-btn--sm" [disabled]="busy" (click)="clearBulkSelection(selection)">Clear selection</button></ng-template>
    </span>
  </div>
</ng-template>
<ng-template #actionPicker let-row>
  <select *ngIf="actionStep && canManage; else actionText" class="br-form-select br-form-select--sm"
          [attr.aria-label]="'Action for ' + (row.title || 'Lead #' + row.leadId)"
          [disabled]="busy || actionsLoading || !actionsLoaded || !actionTypes.length || !membersLoaded"
          (change)="setAction(row, $any($event.target).value); $any($event.target).value = row.nextActionType || ''">
    <option value="" [selected]="!row.nextActionType" disabled>Select action</option>
    <option *ngIf="row.nextActionType && !hasAction(row.nextActionType)" [value]="row.nextActionType" [selected]="true" disabled>{{ row.nextActionType }}</option>
    <option *ngFor="let action of actionTypes" [value]="action.label" [selected]="action.label === row.nextActionType">{{ action.label }}</option>
  </select>
  <ng-template #actionText>{{ row.nextActionType || 'Not set' }}</ng-template>
</ng-template>
<p *ngIf="actionStep && busy" class="br-text-muted" role="status">Saving changes…</p>
<p *ngIf="actionStep && actionsLoading" class="br-text-muted" role="status">Loading Lead actions…</p>
<p *ngIf="actionStep && actionsError" class="br-alert br-alert--danger" role="alert">{{ actionsError }}
  <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" (click)="loadActionTypes()">Retry</button>
</p>
<p *ngIf="actionStep && actionsLoaded && !actionTypes.length" class="br-text-muted" role="status">No active Lead actions are configured.</p>
<p *ngIf="actionStep && assigneesError" class="br-alert br-alert--danger" role="alert">{{ assigneesError }}
  <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" (click)="loadAssignees()">Retry</button>
</p>
<ng-template #removeAction let-row>
  <br-menu aria-label="Campaign lead actions">
    <button *ngIf="selectable" brMenuItem type="button" [disabled]="busy || !membersLoaded" (triggered)="removeMember(row)"
            label="Remove from campaign" icon="link_off"></button>
  </br-menu>
</ng-template>
<ng-template #planEditors let-row>
  <div class="br-flex br-flex-wrap br-items-center br-gap-2 br-mt-2">
    <ng-container *ngTemplateOutlet="assigneePicker; context: { $implicit: row }"></ng-container>
    <ng-container *ngTemplateOutlet="actionPicker; context: { $implicit: row }"></ng-container>
    <ng-container *ngTemplateOutlet="duePicker; context: { $implicit: row }"></ng-container>
  </div>
</ng-template>
<app-leads-board #memberCollection [scopedFetch]="fetch" [listColumns]="columns"
                 [collectionKey]="'campaign-leads-' + step" [pageSizeOptions]="[25, 50, 100]" [selectable]="actionStep && canManage"
                 originLabel="Campaign" [rowActionMenu]="selectable ? removeAction : null"
                 [rowExtras]="actionStep ? planEditors : null" [bulkActions]="actionStep && canManage ? bulkPlan : null">
  <ng-template *ngIf="actionStep" dtCell="salesRep" let-row><ng-container *ngTemplateOutlet="assigneePicker; context: { $implicit: row }"></ng-container></ng-template>
  <ng-template *ngIf="actionStep" dtCell="nextAction" let-row><ng-container *ngTemplateOutlet="actionPicker; context: { $implicit: row }"></ng-container></ng-template>
  <ng-template *ngIf="actionStep" dtCell="nextActionDue" let-row><ng-container *ngTemplateOutlet="duePicker; context: { $implicit: row }"></ng-container></ng-template>
</app-leads-board>
</ng-container>
